<template>
    <div class="retailer-card flex">
        <div class="favorite flex">
            <v-rating
                color="#2D60C2"
                empty-icon="mdi-star"
                full-icon="mdi-star"
                hover
                length="1"
                v-model="item.isFavorite"
            ></v-rating>
        </div>

        <div class="image-section">
            <img :src="item.image" alt="">
        </div>

        <div class="name__place">
            <p class="--font"> {{ item.name }} </p>
            <small class="secondary-font"> {{ item.place }} </small>
        </div>

        <button class="--green"> View Store </button>

        <div class="figures">
            <label >Lead</label>
            <p class="--font"> {{ item.lead }} </p>
        </div>

        <div class="figures">
            <label >Customer</label>
            <p class="--font"> {{ item.customer }} </p>
        </div>

        <div class="figures">
            <label >Conversion</label>
            <p class="--font"> {{ item.conversion }}% </p>
        </div>

        <div class="figures">
            <label >Sell</label>
            <p class="--font"> {{ item.sell }} </p>
        </div>

        <v-icon color="#D0D0D0" class="pointer ml-1">mdi-dots-vertical</v-icon>
    </div>
</template>

<script>
export default {
    name : 'retailerCard',

    props : {
        item : {
            type : Object
        }
    }
}
</script>

<style lang="scss" scoped>

.retailer-card {
    background-color: white;
    box-shadow: 1px 1px 1px rgba(17, 58, 34, 0.07);
    border-radius: 3px;
    justify-content: space-between;
    padding: 10px;
    margin: 5px 0 5px 0;

    p {
        margin: 0;
    }
}

.retailer-card > div {
    width: 11.11%;
}

.favorite {
    background: #F1F3F5;
    border-radius: 3px;
    width: 50px !important;
}

.image-section {
    height: 100%;
}

.image-section img {
    width: 100%;
    height: 100% !important;
}

p {
    font-size: 0.9rem;
}

label {
    color: #A6ACA9;
    font-size: 0.8rem;
}

button {
    font-size: 0.9rem;
    background: #FBFDFC;
    border-radius: 5px;
    padding: 10px;
}

@media all and (min-width : 1400px) {

    .retailer-card {
        padding: 10px 20px;
    }

    p {
        font-size: 1rem;
    }

    label {
        font-size: 0.95rem;
    }

    .image-section {
        width: 8% !important;
    }

    .name__place {
        width: 15% !important;
    }

    button {
        padding: 10px 20px;
    }

    .figures {
        width: 8% !important;
    }
}
</style>